import { removeItem } from '.';

export const DRAFT_ALLOCATION_KEY = 'draftAllocation';
export const EDIT_DRAFT_ALLOCATION_KEY = 'editDraftAllocation';

export const removeDraftAllocation = (): void => removeItem(DRAFT_ALLOCATION_KEY);
